import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Title from "./Title";

export default class TitledForm extends Component {

    render() {
        return (
            <div className={"Content-base" + (this.props.stretch ? " Content-fullPage" : "")}>
                {(this.props.header !== undefined) && (
                    <Fragment>
                        {this.props.header}
                    </Fragment>
                )}
                <Title
                    title={this.props.title}
                    subtitle={this.props.subtitle}
                    size={this.props.titleSize}
                    align={this.props.titleAlign}
                />
                <div className={"Content-section" +
                    (this.props.formSize === "wide" ? " Content-wide" : " Content-compact") +
                    ((this.props.formAlign === "center" || this.props.formAlign === "") ? "" :
                        (this.props.formAlign === "right" ? " Content-right" :
                            (this.props.formAlign === "stretch" ? " Content-stretch" : " Content-left")
                        )
                    )
                }>
                    {this.props.form}
                </div>
                {(this.props.footer !== undefined) && (
                    <Fragment>
                        {this.props.footer}
                    </Fragment>
                )}
            </div>
        );
    }

}

TitledForm.defaultProps = {
    titleAlign: "center",
    titleSize: "normal",
    formAlign: "center",
    formSize: "normal"
}

TitledForm.propTypes = {
    title: PropTypes.node,
    form: PropTypes.node,
    titleAlign: PropTypes.string, // left, center (default), right
    titleSize: PropTypes.string, // normal (default), wide
    formAlign: PropTypes.string, // left, center (default), right
    formSize: PropTypes.string, // normal (default), wide
    stretch: PropTypes.bool,
    footer: PropTypes.node,
    header: PropTypes.node
}